module.exports = __webpack_public_path__ + "jira-1-a4d5c73b935bce192cfc6062f278e1c0.webp";